import { useState, useEffect, useRef } from "react";

export default function SegmentedControl({ options, selected, onChange }) {
  const [pillPosition, setPillPosition] = useState(0);
  const [pillWidth, setPillWidth] = useState(0);
  const containerRef = useRef(null);
  const optionRefs = useRef([]);

  useEffect(() => {
    const selectedIndex = options.findIndex(opt => opt.name === selected);
    if (selectedIndex !== -1 && optionRefs.current[selectedIndex]) {
      const option = optionRefs.current[selectedIndex];
      setPillPosition(option.offsetLeft);
      setPillWidth(option.offsetWidth);
    }
  }, [selected, options]);

  return (
    <div 
      ref={containerRef}
      className="relative bg-lz-paper-border dark:bg-lz-ink-mid rounded-full p-1 flex items-center justify-center"
    >
      <div 
        className="absolute bg-lz-ink-mid dark:bg-lz-candle-dim rounded-full h-[calc(100%-8px)] transition-all duration-300 ease-out"
        style={{ 
          left: `${pillPosition}px`, 
          width: `${pillWidth}px` 
        }}
      />
      {options.map((option, index) => (
        <button
          key={option.name}
          ref={el => optionRefs.current[index] = el}
          onClick={() => onChange(option.name)}
          className={`relative z-10 px-4 py-2 rounded-full font-semibold uppercase transition-colors duration-300 flex-1 ${
            selected === option.name 
              ? "text-white dark:text-lz-concrete" 
              : "text-lz-ink-mid dark:text-white"
          }`}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}
